import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClaimFormDto } from "../features/claims/types";
import { ClaimStatusEnum } from "../features/claims/types/ClaimStatusEnum";
import { TimelineStatusEnum } from "../features/claims/types/enums";

export interface ClaimFormState {
    data: ClaimFormDto;
    errors: {
        [key: string]: string | undefined;
    };
}

const initialState: ClaimFormState = {
    data: {
        id: 0,
        requestTypeId: 1,
        files: [],
        status: ClaimStatusEnum.Open,
        topics: [],
        professionals: [],
        deleteAlert: false,
        alertId: null,
        alertStatus: null,
        timelineStatus: TimelineStatusEnum.On,
        claimsForAffectedPerson: [],
        claimsForClaimant: []
    },
    errors: {}
};

const claimFormSlice = createSlice({
    name: "claimForm",
    initialState,
    reducers: {
        setClaimForm(state, action: PayloadAction<ClaimFormDto>) {
            state.data = action.payload;
        },
        resetClaimForm() {
            return initialState;
        },
        setError(state, action: PayloadAction<{ field: keyof ClaimFormDto | string; message: string | undefined }>) {
            const { field, message } = action.payload;
            state.errors[field] = message;
        },
        clearErrors(state) {
            state.errors = {};
        },
    }
});

export const { setClaimForm, resetClaimForm, setError, clearErrors } = claimFormSlice.actions;
export default claimFormSlice.reducer;
